import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import Avatar from 'shared/components/avatar/Avatar';
import ClientSideHead from './ClientSide/ClientSideHead';
import { getClients } from '../../home/ducks/clientActions';

const MessagesAdd = ({ getClients, clients, channels }) => {
  const [filteredClients, setFilteredClients] = useState([]);
  const [searchVal, setSearch] = useState('');

  useEffect(() => {
    getClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    filterClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, channels, searchVal]);

  const filterClients = () =>
    clients &&
    channels &&
    setFilteredClients(
      clients.filter(
        client =>
          doesClientHaveAChannel(client.id) &&
          `${client.first_name.toLowerCase()} ${client.last_name.toLowerCase()}`.includes(
            searchVal.toLowerCase()
          )
      )
    );

  const doesClientHaveAChannel = clientId =>
    channels.filter(channel => channel.uniqueName.includes(clientId))[0];

  return (
    <div className="messages main-wrapper">
      <div className="container">
        <div className="messages-wrapper">
          <div className="messages-sidebar new-message">
            <div className="client-side">
              <ClientSideHead
                label="New Message"
                btnTxt="Cancel"
                url="/messages"
              />
              <section className="client-search">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    value={searchVal}
                    onChange={e => setSearch(e.target.value)}
                  />
                  <small>To:</small>
                </div>
              </section>
              {clients && channels ? (
                <div className="client-list-container">
                  <Scrollbars autoHide={true}>
                    <ul className="client-list">
                      {filteredClients.map((client, i) => {
                        return (
                          <li key={i}>
                            <Avatar
                              src={client?.photo || ''}
                              width="32"
                              height="32"
                              name={`${client?.first_name} ${client?.last_name}`}
                              firstLetters={`${client?.first_name[0].toUpperCase()}${client?.last_name[0].toUpperCase()}`}
                              url={`/messages?client=${client.id}`}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  </Scrollbars>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
          <div className="messages-content"></div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    clients: state.clientReducer.clients,
    channels: state.messagesReducer.channels
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClients: () => dispatch(getClients())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MessagesAdd);
